import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import styled from 'styled-components';
import COLORS from 'constants/colors';

import { Text, Separator, Button, FlexView } from '@cuemath/comps';
import { Input } from 'semantic-ui-react';
import { LinkNav } from 'modules/form';
import AssignTeacher from './assign-teacher';

import {
  post as createFoundationStudentPaymentLink,
  get as getFoundationStudentPaymentLink,
} from 'actions/foundation-student-payment-link';
import { get as getTeacherDetails } from 'actions/teachers';

const Wrapper = styled(FlexView)`
  margin: 20px;
`;
const StyledFlexView = styled(FlexView)`
  flex-direction: row;
`;
const StyledButton = styled(Button)`
  margin: 10px 15px 10px 0;
`;
const StyledText = styled(Text)`
  margin: 5px;
`;
const ErrorText = styled(Text)`
  margin: 20px;
`;
const TextWrapper = styled(Text)`
  margin: 40px 0;
`;

class FoundationPaymentModal extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      getFoundationStudentPaymentLink: PropTypes.func.isRequired,
      getTeacherDetails: PropTypes.func.isRequired,
      createFoundationStudentPaymentLink: PropTypes.func.isRequired,
    }).isRequired,
    student: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      foundationPaymentLinkPost: store.post(),
      studentDataAvailable: true,
      foundationStudentData: {},
      teacherDetails: null,
      errorText: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const {
      foundationPayment,
      teachers,
      student: { student_service_id: studentServiceId },
    } = props;
    const {
      foundationPaymentLinkPost: { id },
      foundationStudentData: { teacher_id: teacherId = '' },
    } = state;

    const newState = {};

    const foundationPaymentPost = store.post(foundationPayment, id);
    const foundationPaymentGet = store.get(foundationPayment, studentServiceId);

    if (teacherId) {
      const teacherDetailsGet = store.get(teachers, teacherId);
      newState.teacherDetails = teacherDetailsGet.data;
    }

    if (foundationPaymentGet && foundationPaymentGet.isLoaded) {
      if (!foundationPaymentGet.data.payment_link_url) {
        newState.studentDataAvailable = false;
      }
      newState.foundationStudentData = foundationPaymentGet.data;
    } else if (foundationPaymentGet && foundationPaymentGet.isLoadingFailed) {
      const errorObj = store.getError(foundationPaymentGet);
      newState.errorText = errorObj ? errorObj.message : 'Something went wrong';
    }

    if (foundationPaymentPost.resolved && foundationPaymentPost.resolved.isCreated) {
      const {
        resolved: { data = {} },
      } = foundationPaymentPost;
      newState.errorText = '';
      newState.studentDataAvailable = true;
      newState.foundationStudentData = data;
    } else if (
      foundationPaymentPost &&
      foundationPaymentPost.resolved &&
      foundationPaymentPost.resolved.isCreatingFailed
    ) {
      const errorObj = store.getError(foundationPaymentPost.resolved);
      newState.errorText = errorObj ? errorObj.message : 'Something went wrong';
    }

    return newState;
  }

  componentDidMount() {
    const {
      student: { student_service_id: studentServiceId },
      actions,
    } = this.props;
    if (studentServiceId) actions.getFoundationStudentPaymentLink(studentServiceId);
  }

  componentDidUpdate() {
    const {
      studentDataAvailable,
      teacherDetails,
      foundationStudentData: { teacher_id: teacherId = '' },
    } = this.state;
    const { actions } = this.props;

    if (teacherId) {
      if (studentDataAvailable && !teacherDetails) {
        actions.getTeacherDetails(teacherId);
      }
    }
  }

  patchFoundationStudent = teacherId => {
    const {
      actions,
      student: {
        parent_service_id: parentServiceId,
        grade,
        student_service_id: studentServiceId,
      },
    } = this.props;
    const {
      foundationPaymentLinkPost: { id },
    } = this.state;

    const data = {
      parent_service_id: parentServiceId,
      teacher_id: teacherId,
      grade,
    };

    if (!teacherId || !studentServiceId) return;

    actions.createFoundationStudentPaymentLink(id, data, { studentServiceId });
  };

  render() {
    const {
      studentDataAvailable,
      teacherDetails,
      errorText,
      foundationStudentData: {
        payment_link_url: paymentLink = '',
        teacher_update_url: teacherUpdateUrl = '',
        demo_teacher_id: demoTeacherId = '',
      } = {},
    } = this.state;
    const {
      student: { student_service_id: studentServiceId },
    } = this.props;
    const { name = '', phone = '' } = teacherDetails || {};

    if (!studentServiceId)
      return (
        <ErrorText color={COLORS.RED} size="medium" align="center">
          No Student Service Id is linked with this student.
        </ErrorText>
      );

    return studentDataAvailable ? (
      <Wrapper>
        <StyledText size="large" align="center" weight="bold">
          Create Payment Link
        </StyledText>
        <Text size="small">
          This student is created in FOUNDATION, please CHANGE THE TEACHER (if wrong) or
          CREATE PAYMENT LINK
        </Text>
        <Separator height={20} transparent />
        <Text weight="semibold">Assigned Teacher</Text>
        <Input value={`${name}-${phone}`} disabled />
        <StyledFlexView alignItems="center">
          <StyledButton
            onClick={() => window.open(paymentLink, '_blank')}
            label="Create payment link"
          />
          <LinkNav
            target="_blank"
            to={{
              pathname: teacherUpdateUrl,
            }}
          >
            Change Teacher
          </LinkNav>
        </StyledFlexView>
        {errorText && (
          <ErrorText color={COLORS.RED} size="medium">
            {errorText}
          </ErrorText>
        )}
        <TextWrapper>
          <Text size="medium" weight="bold">
            IMPORTANT DIRECTIVES.
          </Text>
          <Separator height={15} transparent></Separator>
          <Text size="small" weight="bold">
            IF CHAGNING THE TEACHER IS REQUIRED
          </Text>
          <Separator height={10} transparent></Separator>
          <Text size="small">
            1. Click on "Change Teacher". You will be redirected to a new page.
          </Text>
          <Text size="small">2. Update Appropriate teacher.</Text>
          <Text size="small">
            3. COME BACK to here i.e. (Leap-admin) & click on "Create Payment Link".
          </Text>
          <Text size="small">4. Select appropriate months & create link.</Text>
        </TextWrapper>
      </Wrapper>
    ) : (
      <AssignTeacher
        patchFoundationStudent={this.patchFoundationStudent}
        errorText={errorText}
        demoTeacherId={demoTeacherId}
      />
    );
  }
}

export default connect(
  ({ foundationPayment, teachers }) => ({ foundationPayment, teachers }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getFoundationStudentPaymentLink,
        createFoundationStudentPaymentLink,
        getTeacherDetails,
      },
      dispatch,
    ),
  }),
)(FoundationPaymentModal);
